import React from 'react';

interface ILoanCheckIcon{
  width?:string;
  height?:string;
  colorStyle?:any;
}
const LoanCheckIcon = ({ width, height, colorStyle }:ILoanCheckIcon) => (
  <svg width={width || '24'} height={height || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill={colorStyle?.fill || '#00C48C'} fillOpacity="0.1" />
    <path d="M7 12.375L10.3764 15.75L17.1264 9" stroke={colorStyle?.stroke || '#00C48C'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
export default LoanCheckIcon;
